import { ToastService } from './../../service/toast.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { map, tap } from "rxjs/operators";

import { environment } from "environments/environment";
import { User, Role } from "app/auth/models";
import { ToastrService } from "ngx-toastr";
import { TokenStorageService } from "../helpers/token-storage.service";

@Injectable({ providedIn: "root" })
export class AuthenticationService {
  //public
  public currentUser: Observable<User>;

  //private
  private currentUserSubject: BehaviorSubject<User>;

  /**
   *
   * @param {HttpClient} _http
   * @param {ToastrService} _toastrService
   */
  constructor(private _http: HttpClient, private _toastrService: ToastrService, 
    private authSrv: TokenStorageService, private modalService: NgbModal, private ToastService:ToastService) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem("currentUser")));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  // getter: currentUserValue
  public get currentUserValue(): User {
    if(localStorage.getItem("currentUser")){
      this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem("currentUser")));
    }    
    return this.currentUserSubject.value;
  }

  /**
   *  Confirms if user is user
   */
  get isUser() {
    return this.currentUser && this.currentUserSubject.value.type === Role.User;
  }


  login(pin: string) {
    const formData = new FormData();
    formData.append("pin", pin);

    return  this._http.post(environment.apiUrl+ '/postAuth/verifPin', formData).pipe(
      tap((data:any) => {
        // login successful if there's a jwt token in the response
        if (data && data.nextToken && data.code === "00") {
          this.authSrv.savenextToken(data.nextToken);
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem("currentUser", JSON.stringify(data.user));
          if (data.marchand) {
            localStorage.setItem("marchand", JSON.stringify(data.marchand));
          }
          localStorage.setItem('pin', 'valide');
          // notify
          this.currentUserSubject.next(data.user);
        }

        return data;
      })
    );
  }

  pin(user) {
    // Display welcome toast!
    setTimeout(() => {
      this.ToastService.success('Global.wlc');
    }, 2500);
  }

  /**
   * User logout
   *
   */
  logout() {
    localStorage.removeItem('marchand');  // remove marchand info
    localStorage.removeItem('display');      // unmark as marchand
    localStorage.removeItem('pin');
    localStorage.removeItem('vC');
    this.modalService.dismissAll();
    // remove user from local storage to log user out
    localStorage.removeItem("currentUser");
    this.authSrv.deleteToken();
    this.authSrv.deletenextToken();
    // notify
    this.currentUserSubject.next(null);
  }
}
